export default {
    '-': "-",
    actions: "Harakatlar",
    actions_with_selected: "Tanlangan bilan harakatlar",
    active: "Faol",
    add: "Qo‘shish",
    add_attachment: "Qo'shiq qo'shish",
    add_condition: "Shart qo‘shish",
    afternoon: "Kunduzi",
    all: "Hammasi",
    app_is_in_maintenance_mode: "Ilovada texnik ishlar olib borilmoqda. Biz albatta tez orada qaytamiz",
    are_you_sure_you_want_to_delete: "Haqiqatan ham materialni o‘chirmoqchimisiz?",
    are_you_sure_you_want_to_logout: "Haqiqatan ham chiqmoqchimisiz?",
    assistant_id: "Yordamchi",
    authorization: "Avtorizatsiya",
    authorize_in_system: "Tizimga avtorizatsiya qiling",
    azerbaijani: "Ozarbayjon",
    balance: "Depozit",
    cancel: "Bekor qilish",
    cancel_verb: "Bekor qilish",
    change: "O‘zgartirish",
    change_password: "Parolni o‘zgartirish",
    comment: "Izoh",
    confirm_deletion: "O‘chirishni tasdiqlash?",
    contacts: "Kontaktlar",
    contains: "O‘z ichiga oladi",
    continue: "Davom ettirish",
    credit: "Kredit",
    currency: "Valyuta",
    custom_role_rights_updated: "Rol huquqlari yangilandi",
    delete: "O‘chirish",
    dentistry: "Stomatologiya",
    do_not_save: "Saqlamang",
    does_not_equal: "Teng emas",
    done: "Tayyor",
    down: "Pastga",
    edit: "Tahrir qilish",
    egisz_send_error: "EGISZ ga yuborishda xatolik",
    egisz_send_success: "EGISZ ga muvaffaqiyatli yuborildi",
    email: "Email",
    email_required_for_password_reset: "Ushbu foydalanuvchining parolini tiklash uchun uning email manzili kiritilishi kerak",
    end: "Tugash",
    english: "Ingliz tili",
    enter_username_to_reset_password: "Parolni tiklash havolasini olish uchun loginingizni kiriting",
    equals: "Teng",
    error: "Xato",
    error_message: "Nimadir xato ketdi, operatsiya muvaffaqiyatli yakunlanmadi",
    evening: "Kechqurun",
    excel: "Excel",
    exported_patients_to_excel: "Bemorlarni Excelga yukladi",
    exported_report_to_excel: "Hisobotni Excelga yukladi",
    fact: "Haqiqat",
    family_account_member_toggled: "Oilaviy hisob ishtirokchisining faolligini o'zgartirdi",
    family_account_updated: "Oilaviy hisob tarkibini yangiladi",
    file: "Fayl",
    file_does_not_exist: "Fayl topilmadi",
    file_size_is_too_big: "Fayl hajmi juda katta",
    filled: "To‘ldirildi",
    filled_not_signed: "To‘ldirilgan / imzolanmagan",
    filter: "Filtr",
    finish: "Tugatish",
    finishing_operation: "Operatsiyani yakunlash",
    forgot_password: "Parolni unutdingizmi?",
    from_to: "{from} dan {to} gacha",
    general_cost: "Umumiy xarajat",
    general_medicine: "Umumiy tibbiyot",
    general_slogan: "Zamonaviy klinikani boshqarish uchun bulutli yechim",
    hide: "Yashirish",
    hide2: "Yashirish",
    home: "Asosiy",
    image: "Rasm",
    import: "Import",
    in_interval: "Oraliqda",
    input_field: "Matnni kiritish uchun maydon",
    integration: "Integratsiya",
    invalid_reset_link: "Bu parolni tiklash havolasi noto‘g‘ri yoki muddati o‘tgan",
    kazakh: "Qozoq",
    kyrgyz: "Qirg'iz",
    KZT: "KZT",
    language: "Til",
    less: "Kamroq",
    links: "Havolalar",
    load_more: "Ko'proq yuklang",
    logged: "Vakolatli",
    logged_out: "Tizimdan chiqdi",
    login: "Login",
    login_disclaimer: "DENTIST PLUS tizimiga kirishni davom ettirib, siz o'zingizning shaxsiy hisobingizdan foydalanayotganingizni tasdiqlaysiz va hisob ma'lumotlaringizdan foydalanib amalga oshirilgan harakatlar uchun javobgarlikni o'z zimmangizga olasiz. Hisob ma'lumotlarini uchinchi shaxslarga berish taqiqlanadi.",
    login_failed: "Tizimga kirish urinishi muvaffaqiyatsiz tugadi",
    login_locked_out: "Kirish bloklandi (ko'p urinish)",
    login_or_pass_incorrect: "Login va / yoki parol noto‘g‘ri",
    logout: "Chiqish",
    main: "Asosiy",
    message: "Xabar",
    module_unavailable: "Modul mavjud emas",
    months: "Oylar",
    more: "Ko‘proq",
    more_2: "Ko'proq",
    morning: "Ertalab",
    must_change_password_notice: "Davom etish uchun parolni o‘zgartirishingiz kerak",
    name: "Nom",
    new_password: "Yangi parol",
    no: "Yo‘q",
    no_data_available: "Hozircha hech qanday ma’lumot yo‘q",
    nonactive: "Faol emas",
    not_enough_rights_for_this_operation: "Ushbu operatsiya uchun huquqlar yetarli emas",
    not_filled: "To‘ldirilmagan",
    nothing_found: "Hech narsa topilmadi",
    old_password: "Eski parol",
    on_page: "Sahifada",
    page_not_found: "Sahifa topilmadi",
    password: "Parol",
    password_changed: "Parol o‘zgartirildi",
    password_confirm: "Parolni tasdiqlash",
    password_reset_link_sent: "Agar bu login bilan hisob mavjud bo‘lsa, uning email manziliga parolni tiklash havolasi yuborildi",
    password_reset_failed: "Parolni tiklash urinishi muvaffaqiyatsiz tugadi",
    password_reset_requested: "Parolni tiklashni so'radi",
    password_reset_succeeded: "Parolni muvaffaqiyatli tikladi",
    passwords_do_not_match: "Parollar mos kelmayapti",
    patient_search: "Bemorni qidirish",
    patient_tags_updated: "Bemor teglarini yangiladi",
    payment_expires_at: "To'lov muddati tugaydi",
    phone: "Telefon",
    photo: "Foto",
    price: "Narx",
    print_noun: "Nashr",
    professional: "Professional",
    profile: "Profil",
    program: "Dastur",
    refresh: "Yangilash",
    registration: "Ro‘yxatga olish",
    requirements: "Talablar",
    reset: "Qayta tiklash",
    reset_password: "Parolni qayta tiklash",
    reset_password_email_note: "Foydalanuvchiga yangi parol o'rnatish uchun email orqali havola yuboriladi",
    reset_success: "Qayta tiklash xati sizning elektron pochtangizga yuborildi",
    role: "Rol",
    russian: "Rus tili",
    save: "Saqlash",
    search: "Qidirish",
    select: "Tanlash",
    send_reset_link: "Havolani yuborish",
    sent: "Yuborildi",
    session_revoked: "Sessiyani bekor qildi",
    sessions_revoked: "Boshqa barcha sessiyalarni bekor qildi",
    settings: "Sozlamalar",
    show: "Ko‘rsatish",
    show_full: "To‘liq ko‘rsatish",
    signin: "Kirish",
    slogan: "Zamonaviy stomatologiyani boshqarish uchun bulutli yechim",
    sorting: "Tartiblash",
    staff_rights_updated: "Xodim huquqlari yangilandi",
    staff_role_updated: "Xodim roli yangilandi",
    start: "Boshlash",
    start_noun: "Boshlash",
    status: "Holat",
    subscription_sum: "Har bir obuna uchun miqdor",
    success_message: "Operatsiya muvaffaqiyatli yakunlandi",
    sum: "Summa",
    system: "Tizimli",
    table_search: "Jadval bo‘yicha qidiruv",
    tech_specialist: "Texnik mutaxassis",
    text: "Matn",
    there_are_unsaved_changes: "Saqlanmagan o'zgarishlar mavjud",
    this_module_is_not_in_tariff: "Bu modul Free tarifga kiritilmagan, siz Standard yoki Premium tarifni ulashingiz kerak, va siz Dentist Plus dasturining katta hajmli funksiyalaridan foydalana olasiz.",
    title: "Nomlanishi",
    to_top: "Yuqoriga",
    today: "Bugun",
    total: "Jami",
    translation: "Tarjima",
    unknown: "Noma’lum",
    upload: "Yuklash",
    web: "Web",
    who_has_access: "Kimga kirish bor",
    wrong_file_format: "Fayl formati noto‘g‘ri",
    yes: "Ha"
}
